import { API_URL } from "$env";
import { ok } from "@libs/assert/ok.js";

ok(API_URL.endsWith("/"), "API_URL must end with a slash");

export const apiOrigin = API_URL.replace(/[/]$/u, "");
